import React from "react";
import styled from "styled-components";
import { getCustomerAccountsUrl } from "../utils/customer-accounts-url";
import { WITHDRAWAL_ENTRY_LABEL } from "../utils/withdrawal-labels";

const ProminentLink = styled.a`
  display: inline-block;
  box-sizing: border-box;
  min-height: 40px;
  padding: 0 20px;
  background-color: #fff;
  color: #0b646f;
  font-size: 12px;
  line-height: 40px;
  letter-spacing: 0.04em;
  text-align: center;
  text-transform: none;
  text-decoration: none;
  transition: 250ms color ease, 250ms background-color ease;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      color: #fff;
      background-color: #0b646f;
    }
  }

  @media (max-width: 768px) {
    font-size: 11px;
    line-height: 38px;
    min-height: 38px;
    padding: 0 16px;
  }
`;

const FooterLink = styled.a`
  display: block;
  font-size: 12px;
  line-height: 40px;
  letter-spacing: 0;
  text-transform: uppercase;
  text-decoration: none;
  color: inherit;
  transition: 250ms color ease;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      color: #e9ccb2;
    }
  }
`;

export const WithdrawalButton = ({
  children = WITHDRAWAL_ENTRY_LABEL,
  className,
  fullWidth = false,
  variant = "button",
}) => {
  const style = fullWidth ? { width: "100%" } : undefined;
  const LinkComponent = variant === "link" ? FooterLink : ProminentLink;

  return (
    <LinkComponent
      href={getCustomerAccountsUrl()}
      className={className}
      style={style}
      target="_self"
      rel="noopener noreferrer"
    >
      {children}
    </LinkComponent>
  );
};
